import React from "react";
import { useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Chip } from "@mui/material";
import PriceUpdatedBadge from "../MembershipAnalytics/PriceUpdatedBadge";
import { priceChangesFor } from "../../utils/subscriptionPriceChanges";

const CustomerList = ({ customers, priceChanges }) => {
  const navigate = useNavigate();

  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "fit-content",
        maxWidth: "calc(100vw - 200px)",
        margin: "0 auto",
        overflowX: "auto",
        "&::-webkit-scrollbar": {
          height: "8px"
        },
        "&::-webkit-scrollbar-track": {
          background: "#f1f1f1",
          borderRadius: "4px"
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#888",
          borderRadius: "4px",
          "&:hover": {
            background: "#555"
          }
        }
      }}
    >
      <Table
        sx={{
          minWidth: 650,
          borderCollapse: "separate",
          "td, th": { borderBottom: "1px solid rgba(224, 224, 224, 1)" }
        }}
        aria-label="customers table"
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Phone</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {customers.map((customer) => (
            <TableRow
              key={customer._id}
              onClick={() => navigate(`/customer/${customer._id}`)}
              sx={{
                cursor: "pointer",
                backgroundColor: !customer.active
                  ? customer.deleted === "yes" || customer.deleted === true
                    ? "#ffebee"
                    : "#fff3e0"
                  : "inherit",
                opacity: !customer.active ? 0.85 : 1,
                "&:hover": {
                  backgroundColor: !customer.active
                    ? customer.deleted === "yes" || customer.deleted === true
                      ? "#ffcdd2"
                      : "#ffe0b2"
                    : "rgba(0, 0, 0, 0.04)"
                }
              }}
            >
              <TableCell component="th" scope="row">
                {`${customer.firstName || ""} ${customer.lastName || ""}`.trim() || "N/A"}
              </TableCell>
              <TableCell>{customer.email || "N/A"}</TableCell>
              <TableCell>{customer.phone || "N/A"}</TableCell>
              <TableCell>
                <Chip
                  label={
                    customer.active
                      ? "Active"
                      : customer.deleted === "yes" || customer.deleted === true
                      ? "Deleted"
                      : "Inactive"
                  }
                  color={
                    customer.active
                      ? "success"
                      : customer.deleted === "yes" || customer.deleted === true
                      ? "error"
                      : "warning"
                  }
                  size="small"
                />
                <div>
                  <PriceUpdatedBadge changes={priceChangesFor(priceChanges, customer._id)} />
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomerList;
